import { invokeApi } from "../../../bl_libs/ApiCalling";
import MaterialTable from "material-table";
import React, { useState, useEffect } from "react";
import { forwardRef } from "react";
import Radio from "@material-ui/core/Radio";
import AddBox from "@material-ui/icons/AddBox";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import Check from "@material-ui/icons/Check";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Clear from "@material-ui/icons/Clear";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Edit from "@material-ui/icons/Edit";
import FilterList from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import Remove from "@material-ui/icons/Remove";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Search from "@material-ui/icons/Search";
import ViewColumn from "@material-ui/icons/ViewColumn";
import DeleteIcon from "@material-ui/icons/Delete";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import { withRouter } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { CircularProgress, TablePagination } from "@material-ui/core";
import moment from "moment";

///-------dialog-transition-------///
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
///-----------------CSS-Classes---------------///
const useStyles = makeStyles({
  hed: {
    fontWeight: "bold",
  },
  clmwdth: {
    width: "10px",
  },
  root: {
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  btnadd: {
    float: "right",
    margin: 10,
  },
});
function WishlistArea(props) {
  console.log(props, "propsssss");
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [del, setDel] = React.useState(false);
  const [addQuestion, setAddQuestion] = React.useState(false);
  const [selectedrow, setrowdata] = React.useState([]);
  const [isLoading, setIsLoading] = useState(true);
  let [data, setData] = useState([]);

  //------------------------------------------>  pagination settings

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [totalCount, setTotalCount] = useState(0);

  //----------------------------------------------------------------
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  //////////////////////////////////////////////////////////////////
  ///---------------------Functions-------------------///

  const cheklat = (lat) => {
    if (lat === 0) {
      return "N/A";
    } else {
      return lat;
    }
  };
  const handleClickOpen = (rowdata) => {
    setrowdata(rowdata);
    setOpen(true);
  };

  const handleClose = () => {
    setDel(false);
    setAddQuestion(false);
    setOpen(false);
  };
  const handlestatus = (rowData) => {
    editstatus(rowData);
  };
  const editstatus = (rowData) => {
    let isActive = 0;
    if (rowData.is_active) {
      isActive = 0;
    } else {
      isActive = 1;
    }
    console.log(rowData, "api data");
    let Data = {
      zip_code: rowData.zip_code,
      latitude: String(rowData.latitude),
      longitude: String(rowData.longitude),
      is_active: isActive,
    };
    const token = localStorage.getItem("token");
    let requestObj = {
      path: `/api/admin/edit_zip_code/${rowData.id}`,
      method: "PUT",
      postData: Data,
      headers: {
        "x-sh-auth": token,
      },
    };
    invokeApi(requestObj).then((res) => {
      //console.log(res, "RESPONSE");
      if (res.code == 200) {
        FetchServiceAreaList();
        //setiswaiting(false);
        //props.history.push("/admin/service-area");
      } else {
        console.log(res);
      }
    });
    return false;
  };
  const handleAddService = () => {
    props.history.push({
      pathname: "/admin/add-service",
      state: { route: "service-area" },
    });
  };
  const handleAgreeClose = () => {
    data = data.filter(function (obj) {
      return obj.id !== selectedrow.id;
    });
    setData(data);
    const service_id = selectedrow.id;
    const token = localStorage.getItem("token");
    let requestObj = {
      path: `/api/admin/delete_wishlist_zipcode/${service_id}`,
      method: "DELETE",
      headers: {
        "x-sh-auth": token,
      },
    };
    invokeApi(requestObj).then((res) => {
      console.log(res.code, "Service Delete response?");
      if (res.code === 200) {
        FetchServiceAreaList();
      } else {
        setDel(true);
      }
    });
    setOpen(false);
  };

  const FetchServiceAreaList = () => {
    setIsLoading(true);
    const token = localStorage.getItem("token");
    let requestObj = {
      path: `/api/admin/list_wishlist_zipcode`,
      method: "GET",
      headers: {
        "x-sh-auth": token,
      },
    };
    invokeApi(requestObj).then((res) => {
      console.log(res, "RESPONSE");
      setIsLoading(false);
      setData(res.list_wishlist_zipcodes);
    });
  };

  useEffect(() => {
    FetchServiceAreaList();
  }, [page, rowsPerPage]);

  const [columns, setColumns] = useState([
    {
      title: <span className={classes.hed}>#</span>,
      width: 150,
      render: (rowData) => <>{rowData.tableData.id + 1}</>,
    },
    {
      title: <span className={classes.hed}>Email</span>,
      field: "email_address",
      sorting: true,
    },
    {
      title: <span className={classes.hed}>Zip Code</span>,
      field: "zipcode",
      sorting: true,
    },
    {
      title: <span className={classes.hed}>Add Date and Time</span>,
      render: (rowData) => moment(rowData.created_at).format("LLLL"),
      sorting: true,
    },
    // {
    //   title: <span className={classes.hed}>Latitude</span>,
    //   render: (rowData) => cheklat(rowData.latitude),
    //   sorting: false,
    // },
    // {
    //   title: <span className={classes.hed}>Longitude</span>,
    //   render: (rowData) => cheklat(rowData.longitude),
    //   sorting: false,
    // },
  ]);
  ///-------------styling-icons---------------------///

  const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => (
      <ChevronRight {...props} ref={ref} />
    )),
    Edit: forwardRef((props, ref) => (
      <Edit className={classes.Icons} {...props} ref={ref} />
    )),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => (
      <ChevronLeft {...props} ref={ref} />
    )),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => (
      <ArrowDownward {...props} ref={ref} />
    )),
    ThirdStateCheck: forwardRef((props, ref) => (
      <Remove {...props} ref={ref} />
    )),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
    DeleteIcon: forwardRef((props, ref) => <DeleteIcon {...props} ref={ref} />),
  };

  if (isLoading) {
    return (
      <div className="Circular-Progress">
        <CircularProgress color="primary" />
      </div>
    );
  }
  return (
    <>
      {/* <Button
        className={classes.btnadd}
        onClick={handleAddService}
        variant="contained"
        color="primary"
      >
       Add Service
      </Button> */}

      <MaterialTable
        style={{ marginTop: "55px" }}
        // components={{
        //   Pagination: () => (
        //     <TablePagination
        //       component="div"
        //       count={totalCount}
        //       page={page}
        //       onChangePage={handleChangePage}
        //       rowsPerPage={rowsPerPage}
        //       onChangeRowsPerPage={handleChangeRowsPerPage}
        //       labelRowsPerPage={<span className="pagination-text">Rows:</span>}
        //     />
        //   ),
        // }}
        actions={[
          {
            icon: () => <DeleteIcon style={{ fill: "#00000" }}></DeleteIcon>,
            tooltip: "Delete Service",
            iconProps: { style: { fontSize: "14px", color: "#000000" } },
            onClick: (event, rowData) => {
              handleClickOpen(rowData);
            },
          },
        ]}
        title="Wishlist Area"
        // Fixed hanging problem on ReRendering
        columns={columns.map((c) => ({ ...c, tableData: undefined }))}
        data={data}
        icons={tableIcons}
        options={{
          actionsColumnIndex: -1,
          search: true,
          searchFieldAlignment: "right",
          searchFieldStyle: { marginRight: "0px" },
          searchFieldVariant: "standard",
          pageSize: 25,
          pageSizeOptions: [25, 50, 100, 200],
          emptyRowsWhenPaging: false,
          headerStyle: {
            backgroundColor: "#c4314b",
            color: "white",
            fontWeight: "bold",
          },
        }}
      />
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">{`Are you sure you want to delete: ${selectedrow.zipcode} ?`}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {selectedrow.zip_code}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Disagree
          </Button>
          <Button onClick={handleAgreeClose} color="primary">
            Agree
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={del}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">{`Something get wrong!`}</DialogTitle>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={addQuestion}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">{}</DialogTitle>(
        <div className="Circular-Progress">
          <CircularProgress color="primary" />
        </div>
        )
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
export default withRouter(WishlistArea);
